<template>
  <!-- container -->
  <div class="vue-drawer">
    <div class="mask" :class="show ? 'active' : ''" @click.stop="hideMask"></div>
    <div ref="drawer" class="drawer" :class="[pos!='left' ? 'drawer-right' : 'drawer-left', show ? 'active' : '']" >
      <!-- drawer -->
      <slot name="drawer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pos: {
      type: String,
      default: 'left'
    },
    tran: {
      type: String,
      default: 'overlay'
    }
  },
  data () {
    return {
      drawerWidth: 0,
      translateX: 0
    }
  },
  watch: {
    show: function () {
      // listener
      if (!this.show) {
        this.$emit('on-hide')
      } else {
        this.$emit('on-show')
      }
      // transition
      if (this.tran === 'overlay') {
        return
      }
      if (!this.show) {
        this.translateX = 0
      } else {
        this.translateX = this.pos === 'left' ? this.drawerWidth : -this.drawerWidth
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth || 300
    })
  },
  methods: {
    hideMask () {
      // this.show = false;
      // 只有当显示了，才触发
      if (this.show) {
        this.$emit('change-show', false)
      }
    }
  }
}
</script>

<style >
  .vue-drawer {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    /*width: 100%;*/
    height: 100%;
    z-index: 100;
  }

  .vue-drawer > .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
    opacity: 0;
    -webkit-transition: opacity ease-in-out 0.38s, visibility ease-in-out 0.38s;
    transition: opacity ease-in-out 0.38s, visibility ease-in-out 0.38s;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .vue-drawer > .active {
    visibility: visible;
    opacity: 1;
  }
  .vue-drawer > .drawer {
    max-width: 600px;
    background-color: #fff;
    position: absolute;
    top: 0;
    height:100%;
    overflow: hidden;
    pointer-events: none;
    visibility: hidden;
    -webkit-transition: visibility 0.38s, -webkit-transform ease-in-out 0.38s;
    transition: visibility 0.38s, -webkit-transform ease-in-out 0.38s;
    transition: transform ease-in-out 0.38s, visibility 0.38s, -webkit-transform ease-in-out 0.38s;
    transition: transform ease-in-out 0.38s, visibility 0.38s;
    will-change: none;
  }
  .vue-drawer > .drawer-left {
    left: 0;
    -webkit-transform: translateX(-102%);
    -ms-transform: translateX(-102%);
    transform: translateX(-102%);
  }
  .vue-drawer > .drawer-right {
    right: 0;
    -webkit-transform: translateX(102%);
    -ms-transform: translateX(102%);
    transform: translateX(102%);
  }
  .vue-drawer > .active {
    pointer-events: inherit;
    visibility: visible;
    -webkit-transform: translateX(0%);
    -ms-transform: translateX(0%);
    transform: translateX(0%);
  }
</style>



// WEBPACK FOOTER //
// SliderBar.vue?ebb88952